export enum PROGRESS_BAR_ELEMENTS {
	NOTSTARTED = 'Not Started',
	APPLICABILITY_ASSESSMENT = 'Applicability Assessment',
	APPLICABILITY_REVIEW = 'Applicability Review',
	GROUPING_ASSESSMENT = 'Grouping Assessment',
	GROUPING_REVIEW = 'Grouping Review',
	SUMMARY_ASSESSMENT = 'Summary Assessment',
	SUMMARY_REVIEW = 'Summary Review',
	MAPPING_ASSESSMENT = 'Mapping Assessment',
	MAPPING_REVIEW = 'Mapping Review',
	COMPLIANCE_ACCEPTANCE = 'Compliance Acceptance',
	COMPLETE = 'Complete',
	IMPACT_ANALYSIS = 'Impact Analysis',
	ACTION_PLAN = 'Action Plan',
}

export enum APPLICABILITY_STATUS {
	APPLICABLE = 'Applicable',
	NOTAPPLICABLE = 'Not Applicable',
	INFORMATIONAL = 'Informational',
}

export enum STATUS_UPDATE_TYPE {
	SAVE = 'Save',
	APPROVE = 'Approve',
	REJECT = 'Reject',
	REVIEW = 'Review',
}

export const APPLICABILITY_STATUS_LABELS = [
	{
		value: APPLICABILITY_STATUS.APPLICABLE,
		label: APPLICABILITY_STATUS.APPLICABLE,
	},
	{
		value: APPLICABILITY_STATUS.NOTAPPLICABLE,
		label: APPLICABILITY_STATUS.NOTAPPLICABLE,
	},
	{
		value: APPLICABILITY_STATUS.INFORMATIONAL,
		label: APPLICABILITY_STATUS.INFORMATIONAL,
	},
];

export const checkBoxInfo = [
	[
		{
			id: 0,
			text: 'The plain language summary is accurate and complete based on the underlying citations.',
			highlightedText: '',
		},
	],
	[
		{
			id: 1,
			text: ' is performing the action',
			highlightedText: 'Who',
		},
		{
			id: 2,
			text: ' the action is.',
			highlightedText: 'What',
		},
		{
			id: 3,
			text: ' and, the action needs to be performed (if applicable).',
			highlightedText: 'When',
		},
	],
];

export enum TASK_LIST_WORKFLOW_STATUS {
	requirementInventory = 'Requirement Inventory',
	group = 'group',
	derivedObligations = 'Derived Obligations',
	requirementsInventory = 'Requirements inventory',
}

export enum FILTER_TYPE {
	THEME_TYPE = 'themeName',
	ISSUANCE_TYPE = 'issuanceType',
	REG_SECTION_TYPE = 'sectionName',
	JURISDICTION_TYPE = 'jurisdiction',
	INTERNATIONA_TYPE = 'jurisdiction',
	FEDERAL_STATES_TYPE = 'jurisdiction',
	OWNER_TYPE = 'assignedUserName',
	CREATED_BY_TYPE = 'createdByName',
	WORK_FLOW_STATUS_TYPE = 'taskStatus',
	PRIORITY_TYPE = 'priority',
	SOURCE_TYPE = 'source',
	REG_BOOK_TYPE = 'bookTitle',
	DISPLAY_ID_TYPE = 'displayId',
}

export enum FILTER_NAME {
	THEME_NAME = 'Theme',
	REG_SECTION_NAME = 'Regulatory Section',
	JURISDICTION_NAME = 'Jurisdiction',
	INTERNATIONA_NAME = 'International',
	FEDERAL_STATES_NAME = 'United States of America',
	OWNER_NAME = 'Owner',
	CREATED_BY_NAME = 'Obligations Created By',
	WORK_FLOW_STATUS_NAME = 'Workflow Status',
	PRIORITY_NAME = 'Obligations Priority',
	CITATION_NAME = 'Citation',
	ISSUANCE_TYPE_NAME = 'Issuance Type',
	REG_BOOK_NAME = 'Reg Book',
	SOURCE = 'Source',
}

export enum ISSUANCE_VALUES {
	REGULATION = 'Category_Regulation',
	LAW = 'Category_Law',
	GUIDANCE = 'Category_Guidance',
}
export const workFlowStatusInfo = [
	{
		label: PROGRESS_BAR_ELEMENTS.NOTSTARTED,
		value: PROGRESS_BAR_ELEMENTS.NOTSTARTED,
		type: FILTER_TYPE.WORK_FLOW_STATUS_TYPE,
	},
	{
		label: PROGRESS_BAR_ELEMENTS.APPLICABILITY_ASSESSMENT,
		value: PROGRESS_BAR_ELEMENTS.APPLICABILITY_ASSESSMENT,
		type: FILTER_TYPE.WORK_FLOW_STATUS_TYPE,
	},
	{
		label: PROGRESS_BAR_ELEMENTS.APPLICABILITY_REVIEW,
		value: PROGRESS_BAR_ELEMENTS.APPLICABILITY_REVIEW,
		type: FILTER_TYPE.WORK_FLOW_STATUS_TYPE,
	},
	{
		label: PROGRESS_BAR_ELEMENTS.GROUPING_ASSESSMENT,
		value: PROGRESS_BAR_ELEMENTS.GROUPING_ASSESSMENT,
		type: FILTER_TYPE.WORK_FLOW_STATUS_TYPE,
	},
	{
		label: PROGRESS_BAR_ELEMENTS.GROUPING_REVIEW,
		value: PROGRESS_BAR_ELEMENTS.GROUPING_REVIEW,
		type: FILTER_TYPE.WORK_FLOW_STATUS_TYPE,
	},
	{
		label: PROGRESS_BAR_ELEMENTS.SUMMARY_ASSESSMENT,
		value: PROGRESS_BAR_ELEMENTS.SUMMARY_ASSESSMENT,
		type: FILTER_TYPE.WORK_FLOW_STATUS_TYPE,
	},
	{
		label: PROGRESS_BAR_ELEMENTS.SUMMARY_REVIEW,
		value: PROGRESS_BAR_ELEMENTS.SUMMARY_REVIEW,
		type: FILTER_TYPE.WORK_FLOW_STATUS_TYPE,
	},
	{
		label: PROGRESS_BAR_ELEMENTS.MAPPING_ASSESSMENT,
		value: PROGRESS_BAR_ELEMENTS.MAPPING_ASSESSMENT,
		type: FILTER_TYPE.WORK_FLOW_STATUS_TYPE,
	},
	{
		label: PROGRESS_BAR_ELEMENTS.MAPPING_REVIEW,
		value: PROGRESS_BAR_ELEMENTS.MAPPING_REVIEW,
		type: FILTER_TYPE.WORK_FLOW_STATUS_TYPE,
	},
	{
		label: PROGRESS_BAR_ELEMENTS.COMPLETE,
		value: PROGRESS_BAR_ELEMENTS.COMPLETE,
		type: FILTER_TYPE.WORK_FLOW_STATUS_TYPE,
	},
];

export const priorityList = [
	{
		label: 'High',
		value: 'High',
		type: FILTER_TYPE.PRIORITY_TYPE,
	},
	{
		label: 'Medium',
		value: 'Medium',
		type: FILTER_TYPE.PRIORITY_TYPE,
	},
	{
		label: 'Low',
		value: 'Low',
		type: FILTER_TYPE.PRIORITY_TYPE,
	},
];
export const sourceList = [
	{
		label: 'CUBE',
		value: 'CUBE',
		type: FILTER_TYPE.SOURCE_TYPE,
	},
	{
		label: 'Manual',
		value: 'Manual',
		type: FILTER_TYPE.SOURCE_TYPE,
	},
];

export const MAPPING_DATA: any = {
	Processes: {
		keyword: 'process',
		idKey: 'processId',
		nameKey: 'processName',
	},
	Risks: {
		keyword: 'risk',
		idKey: 'riskId',
		nameKey: 'riskName',
	},
	Policies: {
		keyword: 'policy',
		idKey: 'policyId',
		nameKey: 'policyName',
	},
	Controls: {
		keyword: 'control',
		idKey: 'controlId',
		nameKey: 'controlName',
	},
};
